// src/components/gavion/i18n/modules/compose.fr.ts
export const composeFr = {
  open: "Écrire un courriel",
  title: "Nouveau courriel",
  to: "À",
  cc: "Cc",
  subject: "Objet",
  template: "Modèle",
  no_template: "Aucun modèle",
  body: "Message",
  attachments: "Pièces jointes",
  add_attachment: "Joindre un fichier",
  // GAVION batch 3 (B3-T14): remaining size, guards and template confirmation
  attachments_remaining: "%{size} restants",
  attachment_blocked: "Type de fichier refusé : %{name}",
  attachment_read_failed: "Impossible de lire %{name}.",
  fix_invalid: "Corrigez les adresses invalides avant d'envoyer.",
  replace_title: "Remplacer l'objet et le message ?",
  replace_body: "Le modèle remplace le texte déjà saisi.",
  attachments_limit: "10 Mo au total",
  // GAVION template attachments
  template_files_loading: "Ajout des pièces jointes du modèle…",
  template_files_failed:
    "Les pièces jointes du modèle n'ont pas pu être ajoutées. Choisissez-le de nouveau ou joignez-les à la main.",
  template_files_too_large:
    "Les pièces jointes du modèle dépassent la limite avec les vôtres (10 Mo, 10 fichiers) : elles n'ont pas été ajoutées.",
  remove_attachment: "Retirer %{name}",
  remove_recipient: "Retirer %{email}",
  add_recipient: "Ajouter",
  send: "Envoyer",
  sending: "Envoi…",
  cancel: "Annuler",
  sent: "Courriel envoyé.",
  invalid_email: "Adresse invalide : %{email}",
  required_to: "Ajoutez au moins un destinataire.",
  required_subject: "Ajoutez un objet.",
  placeholder_left: "Remplacez les passages [[…]] avant d'envoyer.",
  not_connected: "Connectez Microsoft 365 pour envoyer depuis votre boîte.",
  connect_link: "Ouvrir les intégrations",
  demo: {
    schedule: "Planifier une démo",
    reschedule: "Modifier la démo",
    cancel: "Annuler la démo",
    title_book: "Planifier une démo Outlook",
    title_reschedule: "Modifier la démo",
    takeover: "Reprendre la démo",
    title_takeover: "Reprendre la démo",
    takeover_needed:
      "Cette démo est dans l'Outlook de %{rep}, qui n'est plus responsable de l'affaire : elle ne peut plus être modifiée ni rappelée. Reprenez-la pour l'envoyer depuis l'Outlook de %{owner}.",
    takeover_body:
      "Une nouvelle invitation Teams part de l'Outlook de %{owner} vers le client, et les rappels repartent. L'ancienne invitation ne peut pas être annulée : dites au client de l'ignorer.",
    takeover_confirm: "Envoyer la nouvelle invitation",
    taken_over: "Démo reprise : nouvelle invitation envoyée.",
    start: "Date et heure",
    duration: "Durée",
    minutes: "%{n} min",
    attendee: "Courriel du participant (facultatif)",
    confirm: "Créer l'invitation Outlook",
    save: "Enregistrer",
    comment: "Message aux participants (facultatif)",
    booked: "Démo planifiée dans Outlook.",
    moved: "Démo déplacée.",
    cancelled: "Démo annulée dans Outlook.",
    outlook_hint: "Une réunion Teams est ajoutée automatiquement.",
    attendee_suppressed:
      "Invitation impossible : ce participant s'est désabonné ou a demandé de ne pas être contacté.",
    reconnect_needed:
      "Reconnectez Microsoft 365 pour modifier ou annuler cette démo Outlook.",
    reconnect_hint: "Reconnectez Microsoft 365",
    status_loading: "Chargement de l'état Microsoft 365…",
    shifted:
      "Cette heure n'existe pas (changement d'heure) : la démo est placée à %{time}.",
    when: "Démo : %{when} (heure de Toronto)",
    off_hours:
      "Attention : cette heure est en dehors des heures habituelles. Vérifiez AM/PM.",
    off_hours_confirm: "Oui, la démo est bien à %{time}",
    not_connected: "Connectez Microsoft 365 pour créer l'invitation Outlook.",
  },
  message: {
    open: "Ouvrir le message",
    title: "Message",
    loading: "Chargement du message…",
    failed: "Impossible d'afficher ce message.",
    attachments: "Pièces jointes",
    download: "Télécharger %{name}",
    inbound: "Courriel reçu",
    outbound: "Courriel envoyé",
    demo_body: "Contenu du message (démo).",
    reply: "Réponse",
    // GAVION open-pixel
    opened: "Ouvert %{smart_count} fois",
    opened_last: "Ouvert %{smart_count} fois — dernière : %{at}",
    auto_open: "ouverture probablement automatique",
  },
};
